module.exports = __webpack_public_path__ + "img/Topics.84be7e46.svg";